import { type FC, type PropsWithChildren } from 'react'

import { cn } from '@/lib/utils'

export const ActiveCasesWrapper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={cn('flex items-center justify-center', 'h-10', 'gap-[10px]', 'rounded-lg border', 'p-3')}>
      {children}
    </div>
  )
}
